import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, Is_Production } from "../../config.js";
import { decryptData, processEncryptPayload } from "./Cypher.js";
import { showOnce } from "./singletonAlertManager.js";

const getToken = () => sessionStorage.getItem("token");

const baseQuery = fetchBaseQuery({
  baseUrl,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const isTokenExpired = () => {
  const token = getToken();
  if (!token) return true;

  try {
    const tokenData = JSON.parse(atob(token.split(".")[1])); // Decode JWT  
    return tokenData.exp * 1000 < Date.now();
  } catch (err) {
    console.error("Error decoding token:", err);
    return true;
  }
};

const authBaseQuery = async (args, api, extraOptions) => {
  let transformArgs = args;
  if (typeof args !== "string" && Is_Production)
    transformArgs.body = processEncryptPayload(args.body);

  let result = await baseQuery(transformArgs, api, extraOptions);

  let dencrypt;
  if (Is_Production && typeof result?.data?.data === "string") {
    dencrypt = decryptData(result?.data?.data);
    result.data.data = dencrypt || result.data.data;
  }

  if (result.meta?.response) {
    const statusCode = result.meta.response.status;

    if (statusCode === 401) {
      if (!getToken() || isTokenExpired()) {
        console.warn("Token expired or invalid. Logging out...");
        sessionStorage.clear();
        localStorage.removeItem("tab");
        window.location.href = "/login";
        return;
      }
    }
    if (statusCode === 403) {
      console.log("args", args);
      showOnce("auth-403", () => {
        alert(`${result?.error?.data?.message} ${args || "Access denied"}`);
      });
    }
    // console.log("Response status code:", result);

    // Handle errors explicitly
  }
  // console.log("result", result);
  return result;
};

export default authBaseQuery;
